import { Page } from '../../types'

const civilSanctions: Page[] = [
    {
        pageType: 'question',
        title: 'Civil Sanctions',
        name: 'civil-sanctions',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'civil-sanctions-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'civil-sanctions-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'civil-sanctions-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default civilSanctions
